<div class="kyc-container">

  <!-- Status Card (Pending) -->
  <div class="status-card pending" *ngIf="!panVerified || !aadhaarVerified">
    <div class="status-icon">⚠️</div>
    <div class="status-content">
      <h4>KYC Verification Pending</h4>
      <p>Upload your PAN and Aadhaar documents for automatic verification and data extraction.</p>
    </div>
  </div>

  <!-- Document Upload Section -->
  <div class="upload-grid" *ngIf="!panVerified || !aadhaarVerified">
    
    <!-- PAN Card Upload -->
    <div class="upload-card" [class.verified]="panVerified">
      <div class="upload-icon">🪪</div>
      <div class="upload-title">PAN Card Verification</div>
      
      <ng-container *ngIf="!panVerified && !isExtractingPan">
        <p class="upload-desc">Accept PDF, JPG, JPEG, PNG</p>
        <div class="upload-input-wrap">
          <input type="file" id="panUpload" class="upload-input" accept=".pdf,.jpg,.jpeg,.png" (change)="onPanDocumentUpload($event)" />
          <label for="panUpload" class="btn-upload">Click to Upload</label>
        </div>
      </ng-container>
      
      <ng-container *ngIf="panVerified">
        <div class="verified-badge">✓ Verified Successfully</div>
      </ng-container>
      
      <!-- Processing State Overlay -->
      <div class="processing-overlay" *ngIf="isExtractingPan">
        <div class="processing-spinner"></div>
        <div class="processing-text">Analyzing Document</div>
        <div class="processing-subtext">Extracting and validating information...</div>
      </div>
    </div>

    <!-- Aadhaar Card Upload -->
    <div class="upload-card" [class.verified]="aadhaarVerified">
      <div class="upload-icon">🏠</div>
      <div class="upload-title">Aadhaar Verification</div>
      
      <ng-container *ngIf="!aadhaarVerified && !isExtractingAadhaar">
        <p class="upload-desc">Accept PDF, JPG, JPEG, PNG</p>
        <div class="upload-input-wrap">
          <input type="file" id="aadhaarUpload" class="upload-input" accept=".pdf,.jpg,.jpeg,.png" (change)="onAadhaarDocumentUpload($event)" />
          <label for="aadhaarUpload" class="btn-upload">Click to Upload</label>
        </div>
      </ng-container>
      
      <ng-container *ngIf="aadhaarVerified">
        <div class="verified-badge">✓ Verified Successfully</div>
      </ng-container>
      
      <!-- Processing State Overlay -->
      <div class="processing-overlay" *ngIf="isExtractingAadhaar">
        <div class="processing-spinner"></div>
        <div class="processing-text">Analyzing Document</div>
        <div class="processing-subtext">Reading Text & Validating Data...</div>
      </div>
    </div>

  </div>

  <!-- PAN Verification Result Section -->
  <div class="result-section" *ngIf="panVerified">
    <div class="result-card">
      <div class="result-header">
        <span class="result-header-icon">✅</span>
        <h3 class="result-header-title">PAN Verified Successfully</h3>
      </div>
      <div class="result-body">
        <div class="info-grid">
          <div class="info-box">
            <div class="info-label">PAN Number</div>
            <div class="info-value">{{ panNumber || 'N/A' }}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Full Name</div>
            <div class="info-value">{{ panName || 'N/A' }}</div>
          </div>
          <div class="info-box" *ngIf="panDob">
            <div class="info-label">Date of Birth</div>
            <div class="info-value">{{ panDob }}</div>
          </div>
          <div class="info-box" *ngIf="panGender">
            <div class="info-label">Gender</div>
            <div class="info-value">{{ panGender }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Aadhaar Verification Result Section -->
  <div class="result-section" *ngIf="aadhaarVerified && aadhaarResponseData">
    <div class="result-card">
      <div class="result-header">
        <span class="result-header-icon">✅</span>
        <h3 class="result-header-title">Aadhaar Verified Successfully</h3>
      </div>
      <div class="result-body">
        <div class="aadhaar-layout">
          <!-- Left side photo -->
          <div class="aadhaar-photo-container">
            <div class="aadhaar-photo">
              <!-- Using an icon if photo is missing or if we removed base64 to save DB space -->
              👤
            </div>
            <div style="font-size: 12px; color: var(--gray-500); font-weight: 500;">Identity Photo</div>
          </div>
          
          <!-- Right side details -->
          <div class="aadhaar-details">
            <div class="info-grid">
              <div class="info-box">
                <div class="info-label">Aadhaar Number</div>
                <div class="info-value">{{ aadhaarNumber || 'N/A' }}</div>
              </div>
              <div class="info-box">
                <div class="info-label">Name</div>
                <div class="info-value">{{ aadhaarResponseData.name || 'N/A' }}</div>
              </div>
              <div class="info-box" *ngIf="aadhaarResponseData.dateOfBirth">
                <div class="info-label">Date of Birth</div>
                <div class="info-value">{{ aadhaarResponseData.dateOfBirth }}</div>
              </div>
              <div class="info-box" *ngIf="aadhaarResponseData.gender">
                <div class="info-label">Gender</div>
                <div class="info-value">{{ aadhaarResponseData.gender }}</div>
              </div>
              <div class="info-box" *ngIf="aadhaarResponseData.careOf">
                <div class="info-label">Care Of</div>
                <div class="info-value">{{ aadhaarResponseData.careOf }}</div>
              </div>
            </div>

            <!-- Extracted Address Section -->
            <div class="address-card">
              <div class="address-icon">📍</div>
              <div class="address-content">
                <div class="address-label">Verified Registered Address</div>
                <div class="address-value">{{ fullAddress || 'N/A' }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-bar">
    <button class="btn btn-secondary" (click)="prev.emit()">← Back</button>
    <button class="btn btn-primary" (click)="proceedNext()" [disabled]="!canProceed">
      {{ canProceed ? 'Continue to Next Step →' : 'Complete KYC to Continue' }}
    </button>
  </div>

</div>